import { IIconProps } from './types';

/**
 * -----------------------------------------------------------------------------
 * It renders a page like icon with a dollar sign shape in it.
 */
export function DollarQuotationIcon({
  className,
  strokeWidth = 1,
  variant,
}: Readonly<IIconProps>) {
  if (variant !== 'solid') {
    return (
      <svg className={className} fill="none" viewBox="0 0 24 24">
        <path
          d="M17.5 21h-11c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h11c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2ZM14 7.5h2M14 10.5h2M8 15h8M8 18h8M9.5 6.8V6M9.5 11.2v.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
        />
        <path
          d="M8.2 10.7c.2.3.5.5.9.5h.8c.6 0 1.1-.5 1.1-1.1 0-.6-.3-.9-.8-1l-1.4-.4c-.5-.1-.8-.5-.8-1s.5-1.1 1.1-1.1h.8c.4 0 .7.2.9.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
        />
      </svg>
    );
  }

  return (
    <svg className={className} viewBox="0 0 24 24">
      <path d="M17.5 2.2h-11C5 2.2 3.7 3.4 3.7 5v14c0 1.5 1.2 2.8 2.8 2.8h11c1.5 0 2.8-1.2 2.8-2.8V5c0-1.5-1.2-2.8-2.8-2.8ZM8.8 6c0-.4.3-.8.8-.8s.8.3.8.8c.5.2.9.4 1.2.9.2.4.1.8-.2 1-.3.2-.8.1-1-.2 0 0-.1-.2-.3-.2h-.8c-.2 0-.3.1-.3.3 0 .2 0 .3.2.3l1.4.4c.8.2 1.4.9 1.4 1.8s-.7 1.6-1.5 1.8c0 .4-.3.8-.8.8s-.8-.3-.8-.8c-.5-.2-.9-.4-1.2-.9-.2-.4-.1-.8.3-1 .4-.2.8-.1 1 .3 0 0 .1.2.3.2h.8c.2 0 .3-.1.3-.3 0-.2 0-.3-.2-.3l-1.4-.4C8 9.5 7.4 8.8 7.4 8c0-.8.7-1.6 1.5-1.8L8.8 6ZM16 18.8H8c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h8c.4 0 .8.3.8.8s-.3.8-.8.8Zm0-3H8c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h8c.4 0 .8.3.8.8s-.3.8-.8.8Zm0-4.6h-2c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h2c.4 0 .8.3.8.8s-.3.8-.8.8Zm0-3h-2c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h2c.4 0 .8.3.8.8s-.3.8-.8.8Z" />
    </svg>
  );
}
